import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '../../../common/styles/style-constants';

const ToothDamage = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 31 36"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fillRule="evenodd">
      <path d="M30.974 8.98c-.056-2.942-1.447-5.145-3.377-6.412C25.675 1.286 23.31.818 21.052.813c-1.896.003-3.722.335-5.216.916-1.495-.583-3.32-.913-5.218-.917-2.256.004-4.622.473-6.545 1.755C2.143 3.834.75 6.038.696 8.98v.012c-.004.18-.006.365-.008.555-.025 3.615 1.047 5.568 1.958 7.15.885 1.604 1.634 2.866 1.658 6.29.005 4.647.758 7.61 1.875 9.517 1.097 1.894 2.66 2.716 3.974 2.716h.023c.37 0 .713-.058 1.036-.176.492-.178.865-.56 1.075-.93.216-.375.326-.756.405-1.15.153-.786.18-1.657.203-2.623.04-1.92.066-4.185.646-6.105.243-.824.542-1.697.937-2.283.402-.57.733-.837 1.355-.907.622.07.952.337 1.356.907.395.585.694 1.46.937 2.283.77 2.532.547 5.61.724 7.807.075.747.162 1.413.532 2.073.21.37.582.75 1.083.93.312.114.66.175 1.027.175 1.32.01 2.894-.81 4-2.716 1.115-1.908 1.867-4.87 1.872-9.517.026-3.424.774-4.686 1.66-6.29.91-1.58 1.985-3.535 1.958-7.15 0-.19-.003-.377-.008-.567zM27 15.556c-.925 1.605-1.983 3.642-1.96 7.43.006 4.4-.74 6.975-1.55 8.34-.823 1.37-1.602 1.56-1.997 1.57-.05 0-.094-.003-.132-.01-.03-.07-.072-.2-.104-.375-.1-.484-.14-1.286-.16-2.225-.05-1.89-.04-4.356-.743-6.717-.26-.858-.585-1.93-1.227-2.903-.617-.967-1.726-1.872-3.22-1.947l-.07-.003-.07.003c-1.494.075-2.603.98-3.22 1.947-.642.973-.967 2.044-1.227 2.903-.922 3.102-.635 6.438-.817 8.298-.037.503-.133.878-.192 1.022-.036.005-.08.01-.132.01-.394-.01-1.175-.203-1.997-1.572-.81-1.366-1.555-3.94-1.55-8.338.025-3.787-1.035-5.827-1.958-7.43-.898-1.627-1.633-2.787-1.66-6.01 0-.156.004-.325.007-.506.08-2.283.978-3.6 2.347-4.543C6.41 3.792 7.78 3.372 9.224 3.212l2.437-.033c1.416.11 2.746.432 3.698.866l.48.215.475-.213c1.188-.54 2.952-.914 4.74-.91 1.93-.004 3.878.43 5.253 1.36 1.37.946 2.265 2.26 2.347 4.546.005.177.01.346.01.504-.03 3.224-.764 4.383-1.662 6.01z" />
      <path d="M9.706 2.583l-2.95 5.72 6.09-.203-3.418 5.51h4.127l-1.085 3.114 3.756-4.568-3.25-.137 4.093-5.69-5.583-.303 2.063-3.325" />
    </g>
  </svg>
);

ToothDamage.defaultProps = {
  color: colors.blue,
};

ToothDamage.propTypes = {
  color: PropTypes.string,
};

export default ToothDamage;
